import React, { FC, ReactElement, JSXElementConstructor } from 'react';
import { DateTimePicker, DateTimePickerProps, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getDefaultOptions } from 'date-fns';
import { DefaultDateOptions } from './DefaultDateOptions';
import { TextField, TextFieldProps } from '@mui/material';

const LocalizedDateTimePicker: FC<LocalizedDateTimePickerProps> = ({
  renderInputTextField,
  ...props
}: LocalizedDateTimePickerProps) => {
  const defaultOptions: DefaultDateOptions = getDefaultOptions() as DefaultDateOptions;
  const locale = defaultOptions.locale;

  return (
    <LocalizationProvider locale={locale} dateAdapter={AdapterDateFns}>
      <DateTimePicker
        {...props}
        renderInput={(
          params: TextFieldProps
        ): ReactElement<any, string | JSXElementConstructor<any>> => (
          <TextField {...params} {...renderInputTextField} />
        )}
      />
    </LocalizationProvider>
  );
};

export interface LocalizedDateTimePickerProps
  extends Omit<DateTimePickerProps<Date, Date>, 'renderInput'> {
  renderInputTextField: TextFieldProps;
}

export default LocalizedDateTimePicker;
